"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPointData = exports.updatePointInformation = exports.setPointMetadata = void 0;
var setStreamInfo_1 = __importDefault(require("../actions/point/setStreamInfo"));
var initialState = {};
setPointMetadata.type = "point/setMetadata";
function setPointMetadata(metadata) {
    return {
        type: setPointMetadata.type,
        payload: {
            metadata: metadata,
        },
    };
}
exports.setPointMetadata = setPointMetadata;
updatePointInformation.type = "point/set";
function updatePointInformation(pointInfo) {
    return {
        type: updatePointInformation.type,
        payload: {
            pointInfo: pointInfo,
        },
    };
}
exports.updatePointInformation = updatePointInformation;
clearPointData.type = "point/clearPointData";
function clearPointData() {
    return {
        type: clearPointData.type,
        payload: {},
    };
}
exports.clearPointData = clearPointData;
function pointReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case setPointMetadata.type:
            return __assign(__assign({}, state), { metadata: __assign(__assign({}, ((state === null || state === void 0 ? void 0 : state.metadata) || {})), action.payload.metadata) });
        case updatePointInformation.type:
            return __assign(__assign(__assign({}, (!!action.payload.pointInfo ? state : {})), (action.payload.pointInfo || {})), { metadata: __assign(__assign({}, ((state === null || state === void 0 ? void 0 : state.metadata) || {})), { lastUpdate: Date.now() }) });
        case clearPointData.type:
            return {};
        case setStreamInfo_1.default.type:
            return __assign(__assign({}, state), { streamId: action.payload.streamId, streamTitle: action.payload.streamTitle });
        default:
            return state;
    }
}
exports.default = pointReducer;
//# sourceMappingURL=point.js.map